// extracted by mini-css-extract-plugin
module.exports = {"formatedText":"FormatedText_formatedText__31J2s"};